import React from "react";

import {
    initialState,
    reducer,
    ViewMode,
    actions,
    ICurrentGroup,
    IAppState,
    ICurrentUser,
    ICurrentCredit,
} from "./state";

interface IMainContextState {
    ui: IAppState["ui"];
    settingMode: (payload: ViewMode) => void;
    setCurrentGroup: (payload: ICurrentGroup | null) => void;
    setCurrentUser: (payload: ICurrentUser | null) => void;
    setCurrentCredit: (payload: ICurrentCredit) => void;
    setCachedPath: (payload: string) => void;
    reset: () => void;
}

/*** Main app context ***/
export const MainContext = React.createContext<IMainContextState>({
    ui: initialState["ui"],
    settingMode: () => {},
    setCurrentGroup: () => {},
    setCurrentUser: () => {},
    setCurrentCredit: () => {},
    setCachedPath: () => {},
    reset: () => {},
});

const ContextProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    const value: IMainContextState = {
        ui: state.ui,
        settingMode: (payload: ViewMode) => {
            dispatch({ type: actions.SET_VIEW_MODE, payload });
        },
        setCurrentGroup: (payload: ICurrentGroup | null) => {
            dispatch({ type: actions.SET_CURRENT_GROUP, payload });
        },
        setCurrentUser: (payload: ICurrentUser | null) => {
            dispatch({ type: actions.SET_CURRENT_USER, payload });
        },
        setCurrentCredit: (payload: ICurrentCredit) => {
            dispatch({ type: actions.SET_CURRENT_CREDIT, payload });
        },
        setCachedPath: (payload: string) => {
            dispatch({ type: actions.SET_CACHED_PATH, payload });
        },
        reset: () => {
            dispatch({ type: actions.SET_CURRENT_GROUP, payload: null });
            dispatch({ type: actions.SET_CURRENT_USER, payload: null });
            dispatch({ type: actions.SET_CURRENT_CREDIT, payload: null });
            dispatch({ type: actions.SET_CACHED_PATH, payload: null });
            dispatch({ type: actions.SET_VIEW_MODE, payload: null });
        },
    };

    return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
};

export default ContextProvider;
